export const Button = ({ children, className, ...props }) => (
  <button className={`px-4 py-2 rounded-md ${className}`} {...props}>
    {children}
  </button>
);

export const Input = ({ className, ...props }) => (
  <input
    className={`px-3 py-2 border rounded-md focus:outline-none ${className}`}
    {...props}
  />
);
